import { render } from "./Activity-Details.vue?vue&type=template&id=41cfc7b7&scoped=true"
import script from "./Activity-Details.vue?vue&type=script&lang=js"
export * from "./Activity-Details.vue?vue&type=script&lang=js"

import "./Activity-Details.vue?vue&type=style&index=0&id=41cfc7b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41cfc7b7"

export default script